module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "c"
  }, [_vm._v("Seduced by Shark Shifters IV: Mark’s Midlife")]), _vm._v(" "), _c('p', {
    staticClass: "c1"
  }, [_vm._v("By Rafe Jadison")]), _vm._v(" "), _c('p', {
    staticClass: "c1"
  }, [_vm._v("Copyright 2020 Rafe Jadison")]), _vm._v(" "), _c('p', {
    staticClass: "c1"
  }, [_vm._v("Smashwords Edition")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2bb6e42e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/tmp_ca994ea13a81e463652c4b21610dab80_aZl3I6.ch.fixed.fc.tidied.stylehacked.xfixed_split_000.vue
// module id = 57
// module chunks = 0